export default "__VITE_ASSET__CK5Q9AHi__"